'use client';

import { useState, useEffect } from 'react';

// Hooks
import ArrowBoxUpIcon from '@shared/icons/ArrowBoxUpIcon';

// Utils
import { combineClasses } from '@shared/utils';

// Constants
import { KEYBOARD_EVENT } from '@shared/constants';
interface ScrollToTopButtonProps {
  className?: string;
  showAfterScrollY?: number;
}
export const ScrollToTopButton = ({
  className,
  showAfterScrollY = 100
}: ScrollToTopButtonProps) => {
  const [shouldShow, setShouldShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShouldShow(scrollY > showAfterScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showAfterScrollY]);
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === KEYBOARD_EVENT.ENTER || event.key === KEYBOARD_EVENT.SPACE) {
      event.preventDefault();
      handleScrollToTop();
    }
  };
  return shouldShow && <button tabIndex={0} aria-label="Scroll to top of page" title="Scroll to top" className={combineClasses('flex size-fit rounded-[12px]', 'transition-all duration-200 ease-in-out', 'hover:scale-105 active:scale-95', 'disabled:opacity-50 disabled:cursor-not-allowed', className)} onClick={handleScrollToTop} onKeyDown={handleKeyDown}>
        <ArrowBoxUpIcon aria-hidden="true" />
      </button>;
};